import React, { useState, useEffect, useContext } from 'react';



import { FcKindle } from "react-icons/fc";

import Loader from '../../../components/loader/loader';
import { numberFormatter, totalFormatter, decimalFormatter } from '../../../components/formatters/numberFormatter';
import { dateFormatter } from '../../../dynamic/dateFormatter';
import { typeFormatter, paymentTypeFormatter } from '../../../components/formatters/defFormatter';
import { dateTableFormatter } from '../../../dynamic/dateFormatter';
import toast from 'react-hot-toast';
import { FiRotateCcw } from "react-icons/fi";
import { Space, Input, Switch, Button, Spin, Modal, Card, Tabs } from 'antd';

import Select from 'react-select';
import AsyncSelect from 'react-select/async';

import { Col, Form, Row, DropdownButton, Dropdown, InputGroup } from 'react-bootstrap';


import { FiEdit } from "react-icons/fi";
import { FcUndo, FcRefresh, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiExport } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcPlus } from "react-icons/fc";
import { HiMinusCircle } from "react-icons/hi";

import { DataContext } from '../../../init/getData';




function PrintingOptions(props) {

  let { type, isDebit } = props;

  const { api, userData, currencyData, settingData, companyId, refData, yearId, contentLanguages } = useContext(DataContext);
  const userRole = userData.role;
  const [loadingCounter, setLoadingCounter] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [loadingEffect, setLoadingEffect] = useState(false);
  const [isSpinning, setIsSpinning] = useState(false);
  const [setting, setSetting] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const dataArray = ['setting']
        await refData(dataArray, companyId);
        setIsLoading(false);
      } catch (error) {
        console.error('Error refreshing data Contact Support');
      }
    };
    fetchData();
  }, []);


  useEffect(() => {
    setSetting({
      detailsPrint: settingData.detailsPrint,
      discountPrint: settingData.discountPrint,
      itemPricePrint: settingData.itemPricePrint,
      printingNamePrint: settingData.printingNamePrint,
      printingAddressPrint: settingData.printingAddressPrint,
      printingPhonePrint: settingData.printingPhonePrint,
      printingName: settingData.printingName,
      printingAddress: settingData.printingAddress,
      printingPhone: settingData.printingPhone,
      categoryPrint: settingData.categoryPrint,
      pricePrint: settingData.pricePrint,
      unitsPrint: settingData.unitsPrint,
      netQuantityPrint: settingData.netQuantityPrint,
      netPricePrint: settingData.netPricePrint,
      quantityPrint: settingData.quantityPrint,
      vatPrint: settingData.vatPrint,
      totalPricePrint: settingData.totalPricePrint,
      pricePerUnitAfterDiscountPrint: settingData.pricePerUnitAfterDiscountPrint,
      pointPrint: settingData.pointPrint,
      printCurrencyRate: settingData.printCurrencyRate,
    })
  }, [isLoading]);


  const handleSubmit = async () => {


    setLoadingEffect(true);

    const data = {
      setting,
      companyId,
    }


    let res = await api.post(`/setting/edit`, data)
    if (res.data.status) {
      toast.success(res.data.message);
      const dataArray = ['setting']
      await refData(dataArray, companyId);
    }
    else {
      toast.error(res.data.message);
    }
    setLoadingEffect(false);
  }


  const handleChange = (name, value) => {
    setSetting((prev) => ({
      ...prev,
      [name]: value,
    }));
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSetting((prev) => ({
      ...prev,
      [name]: value,
    }));
  };


  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>

      <Spin spinning={loadingEffect} fullscreen />

      {isLoading &&
        <Loader />
      }

      {!isLoading &&
        <Card style={{ width: '300px' }}>

          <Row className="mb-3">
            <Col md={1}>
            </Col>
            <Col md={6}>
              <Form.Label>{contentLanguages.PrintName}</Form.Label>
            </Col>
            <Col>
              <Switch style={{ backgroundColor: setting.printingNamePrint ? '#23576a' : '#bebfbe' }}
                checked={setting.printingNamePrint}
                onChange={(e) => handleChange('printingNamePrint', e)} />
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={1}>
            </Col>
            <Col md={6}>
              <Form.Label>{contentLanguages.PrintAddress}</Form.Label>
            </Col>
            <Col>
              <Switch style={{ backgroundColor: setting.printingAddressPrint ? '#23576a' : '#bebfbe' }}
                checked={setting.printingAddressPrint}
                onChange={(e) => handleChange('printingAddressPrint', e)} />
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={1}>
            </Col>
            <Col md={6}>
              <Form.Label>{contentLanguages.PrintPhone}</Form.Label>
            </Col>
            <Col>
              <Switch style={{ backgroundColor: setting.printingPhonePrint ? '#23576a' : '#bebfbe' }}
                checked={setting.printingPhonePrint}
                onChange={(e) => handleChange('printingPhonePrint', e)} />
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={1}>
            </Col>
            <Col md={6}>
              <Form.Label>{contentLanguages.PrintDetails}</Form.Label>
            </Col>
            <Col>
              <Switch style={{ backgroundColor: setting.detailsPrint ? '#23576a' : '#bebfbe' }}
                checked={setting.detailsPrint}
                onChange={(e) => handleChange('detailsPrint', e)} />
            </Col>
          </Row>


          <Row className="mb-3">
            <Col md={1}>
            </Col>
            <Col md={6}>
              <Form.Label>{contentLanguages.PrintDiscount}</Form.Label>
            </Col>
            <Col>
              <Switch style={{ backgroundColor: setting.discountPrint ? '#23576a' : '#bebfbe' }}
                checked={setting.discountPrint}
                onChange={(e) => handleChange('discountPrint', e)} />
            </Col>
          </Row>


          <Row className="mb-3">
            <Col md={1}>
            </Col>
            <Col md={6}>
              <Form.Label>{contentLanguages.PrintItemPrice}</Form.Label>
            </Col>
            <Col>
              <Switch style={{ backgroundColor: setting.itemPricePrint ? '#23576a' : '#bebfbe' }}
                checked={setting.itemPricePrint}
                onChange={(e) => handleChange('itemPricePrint', e)} />
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={1}>
            </Col>
            <Col md={6}>
              <Form.Label>{contentLanguages.PrintCategory}</Form.Label>
            </Col>
            <Col>
              <Switch style={{ backgroundColor: setting.categoryPrint ? '#23576a' : '#bebfbe' }}
                checked={setting.categoryPrint}
                onChange={(e) => handleChange('categoryPrint', e)} />
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={1}>
            </Col>
            <Col md={6}>
              <Form.Label>{contentLanguages.PrintUnits}</Form.Label>
            </Col>
            <Col>
              <Switch style={{ backgroundColor: setting.unitsPrint ? '#23576a' : '#bebfbe' }}
                checked={setting.unitsPrint}
                onChange={(e) => handleChange('unitsPrint', e)} />
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={1}>
            </Col>
            <Col md={6}>
              <Form.Label>{contentLanguages.PrintNetQuantity}</Form.Label>
            </Col>
            <Col>
              <Switch style={{ backgroundColor: setting.netQuantityPrint ? '#23576a' : '#bebfbe' }}
                checked={setting.netQuantityPrint}
                onChange={(e) => handleChange('netQuantityPrint', e)} />
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={1}>
            </Col>
            <Col md={6}>
              <Form.Label>{contentLanguages.PrintQuantity}</Form.Label>
            </Col>
            <Col>
              <Switch style={{ backgroundColor: setting.quantityPrint ? '#23576a' : '#bebfbe' }}
                checked={setting.quantityPrint}
                onChange={(e) => handleChange('quantityPrint', e)} />
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={1}>
            </Col>
            <Col md={6}>
              <Form.Label>{contentLanguages.PrintNetPrice}</Form.Label>
            </Col>
            <Col>
              <Switch style={{ backgroundColor: setting.netPricePrint ? '#23576a' : '#bebfbe' }}
                checked={setting.netPricePrint}
                onChange={(e) => handleChange('netPricePrint', e)} />
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={1}>
            </Col>
            <Col md={6}>
              <Form.Label>{contentLanguages.PrintVat}</Form.Label>
            </Col>
            <Col>
              <Switch style={{ backgroundColor: setting.vatPrint ? '#23576a' : '#bebfbe' }}
                checked={setting.vatPrint}
                onChange={(e) => handleChange('vatPrint', e)} />
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={1}>
            </Col>
            <Col md={6}>
              <Form.Label>{contentLanguages.PrintTotalPrice}</Form.Label>
            </Col>
            <Col>
              <Switch style={{ backgroundColor: setting.totalPricePrint ? '#23576a' : '#bebfbe' }}
                checked={setting.totalPricePrint}
                onChange={(e) => handleChange('totalPricePrint', e)} />
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={1}>
            </Col>
            <Col md={6}>
              <Form.Label>Price per Unit After Discount Print</Form.Label>
            </Col>
            <Col>
              <Switch style={{ backgroundColor: setting.pricePerUnitAfterDiscountPrint ? '#23576a' : '#bebfbe' }}
                checked={setting.pricePerUnitAfterDiscountPrint}
                onChange={(e) => handleChange('pricePerUnitAfterDiscountPrint', e)} />
            </Col>
          </Row>


          <Row className="mb-3">
            <Col md={1}>
            </Col>
            <Col md={6}>
              <Form.Label>{contentLanguages.PointPrint}</Form.Label>
            </Col>
            <Col>
              <Switch style={{ backgroundColor: setting.pointPrint ? '#23576a' : '#bebfbe' }}
                checked={setting.pointPrint}
                onChange={(e) => handleChange('pointPrint', e)} />
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={1}>
            </Col>
            <Col md={6}>
              <Form.Label>{contentLanguages.printCurrencyRate}</Form.Label> 
            </Col>
            <Col>
              <Switch style={{ backgroundColor: setting.printCurrencyRate ? '#23576a' : '#bebfbe' }}
                checked={setting.printCurrencyRate}
                onChange={(e) => handleChange('printCurrencyRate', e)} />
            </Col>
          </Row>







          <Row className="mb-1">
            <Col md={1}></Col>
            <Col md={12}>
              <Form.Label>{contentLanguages.PrintingName}:</Form.Label>
            </Col>
            <Col md={12}>
              <InputGroup>
                <Form.Control
                  type="text"
                  name="printingName"
                  onChange={handleInputChange}
                  value={setting.printingName}
                  placeholder="Enter printing name"

                />
              </InputGroup>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={1}></Col>
            <Col md={12}>
              <Form.Label>{contentLanguages.PrintingAddress}:</Form.Label>
            </Col>
            <Col md={12}>
              <InputGroup>
                <Form.Control
                  type="text"
                  name="printingAddress"
                  onChange={handleInputChange}
                  value={setting.printingAddress}
                  placeholder="Enter printing address"
                />
              </InputGroup>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={1}></Col>
            <Col md={12}>
              <Form.Label>{contentLanguages.PrintingPhone}:</Form.Label>
            </Col>
            <Col md={12}>
              <InputGroup>
                <Form.Control
                  type="text"
                  name="printingPhone"
                  onChange={handleInputChange}
                  value={setting.printingPhone}
                  placeholder="Enter printing phone"
                />
              </InputGroup>
            </Col>
          </Row>







          <Row>
            <Col md={5}>
            </Col>
            <Col md={6}>
              <Button style={{ backgroundColor: '#23576a', color: 'white' }} onClick={handleSubmit}>{contentLanguages.Save}</Button>
            </Col>
          </Row>



        </Card >
      }

    </div >


  )
}

export default PrintingOptions;
